<template>
  <div class="d-flex ga-5 align-center">
    <div class="d-flex flex-column align-center">
      <span class="f-body-1 hidden-sm-and-down">Favorite Skill</span>
      <v-checkbox
        :readonly="isHiringmanager"
        :disabled="islimited(skill.IsTopSkill) || loading"
        v-model="skill.IsTopSkill"
        @change="changeSkillStatus"
        hide-details
      ></v-checkbox>
    </div>
    <div class="flex-grow-1">
      <v-card class="b-dark">
        <v-card-text>
          <div class="d-flex ga-3 ga-md-8 justify-space-between align-center">
            <div class="d-flex ga-3 ga-md-8 align-center">
              <div class="d-flex ga-3 ga-md-8 align-center">
                <img class="item-card-icons" src="@/assets/images/skill-icon.svg" />
                <h4>{{ getSkillName(skill.SkillId) }}</h4>
              </div>

              <span class="f-body-1 hidden-sm-and-down">{{ skill.Level }} </span>
              <span class="f-body-1 hidden-sm-and-down">{{ skill.TotalExperienceYears }} </span>
              <div v-if="!isHiringmanager && skill.Certificate" class="hidden-sm-and-down">
                <a href="#" @click.prevent="skillDownload(skill.SkillId)" target="_blank"><v-icon>mdi-attachment</v-icon></a>
              </div>
              <span class="f-body-1 hidden-sm-and-down">Assessment: {{ skill.Assessment }}</span>
            </div>
            <div class="d-flex ga-2">
              <v-btn v-if="!isHiringmanager" icon="mdi-pen" class="c-black b-white" :disabled="loading" @click="edit" />
              <v-btn v-if="!isHiringmanager" icon="mdi-delete" class="c-black b-white" :disabled="loading" @click="remove" />
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script lang="ts">
import { TeammemberSkill } from "../../../models/Teammember";
import { defineComponent } from "vue";
import CoreSkill from "../../../models/CoreSkill";
import AddOrEditSkill from "./AddOrEditSkill.vue";
import { ProjectMessages } from "../../../definitions/constants";
import { Profile } from "../../../definitions/config";
import ConfirmDialog from "../../ConfirmDialog.vue";
import AutoCompleteField from "../../Fields/AutoCompleteField.vue";
import ComboBoxField from "../../Fields/ComboBoxField.vue";
import InfoBox from "../../InfoBox.vue";

export default defineComponent({
  props: [
    "skills",
    "teammemberSkills",
    "showEditSkillModal",
    "addSkillLoading",
    "removeSkillloading",
    "sendReqeustLoading",
    "uploadedCertificate",
    "isGettingAllSection",
    "tmModel",
    "saveRoleAndTitleLoading",
    "details",
    "isHiringmanager",
    "skill",
    "teammemberSkillList",
    "skillList",
  ],
  components: {
    AddOrEditSkill,
    ConfirmDialog,
    ComboBoxField,
    AutoCompleteField,
    InfoBox,
  },
  data() {
    return {
      isGettingSkill: false,
      loading: false,
      experienceYearList: Profile.Members.SkillExperienceList,
      shouldRequest: true,
      filteredSkills: [] as CoreSkill[],
      teammemberSkillModel: {} as TeammemberSkill,
      editingSkillModel: {} as TeammemberSkill,
      showLevel: false,
      showYear: false,
      showEdit: false,
      comboboxSkillString: "",
      requestLoading: false,
      uploadedCertificateUrl: "",
      showSave: false,
      selectedSkill: null as CoreSkill | null,
      selectedJobRoles: null,
      selectedJobTitle: null,
      selectedSkillLevel: "",
      selectedTotalExperienceYear: "0",
      showJobRequestConfirm: false,
      sendReqeustLoadingProgress: false,
      headers: [
        { sortable: false, title: "Skill", value: "SkillId" },
        { sortable: false, title: "Favorite skill", value: "IsTopSkill", align: "center" },
        { sortable: false, title: "Level", value: "Level" },
        { sortable: false, title: "Total years", value: "TotalExperienceYears", align: "center" },
        { sortable: false, title: "Certificate", value: "Certificate", align: "center" },
        { sortable: false, title: "Assessment", value: "Assessment", align: "center" },
        { sortable: false, title: "Actions", value: "Actions" },
      ],
      rules: {
        required: (value: any) => !!value || "Required.",
      },
      confirmModel: {
        title: ProjectMessages.removeCareerHistory,
        text: ProjectMessages.confirmation,
      },
    };
  },
  methods: {
    async saveRoleAndTitle() {
      var isValid = (await (this.$refs.frmMain as any).validate()).valid;
      if (isValid) {
        this.$emit("saveRoleAndTitle", { Roles: this.selectedJobRoles, Title: this.selectedJobTitle });
      }
    },
    cancelSending(): void {
      this.showJobRequestConfirm = false;
    },
    async confirmSendJobRequest(selectedJob: any) {
      this.sendReqeustLoadingProgress = true;
      this.sendReqeustLoadingProgress = false;
      this.showJobRequestConfirm = false;
    },
    sendTitleRequest() {
      this.confirmModel.title = "Sending request to add a Job Title";
      this.confirmModel.text = "Are you sure you want to send request to admin to add This?";
      this.showJobRequestConfirm = true;
    },
    islimited(isTopSkill: any) {
      var res = false;
      var findTopSkills = this.teammemberSkillList.filter((c: any) => c.IsTopSkill);
      if (findTopSkills && findTopSkills.length >= Profile.Members.FavoriteSkillLimit && !isTopSkill) {
        res = true;
      }
      return res;
    },
    changeSkillStatus(item: TeammemberSkill) {
      this.$emit("changeSkillStatus");
    },
    skillDownload(certificateUrl: any) {
      this.$emit("skillDownload", certificateUrl);
    },
    skillCertificateChanged(skill: any) {
      this.$emit("skillCertificateChanged", skill);
    },
    remove() {
      this.$emit("remove");
    },
    edit() {
      this.$emit("edit");
    },
    getSkillName(skillId: any) {
      var skill = this.skillList.find((c: any) => c.id === skillId);
      if (skill) {
        return skill.Text;
      }
    },
    resetSkillForm() {
      this.showLevel = false;
      this.showSave = false;
      this.selectedSkillLevel = "";
      this.selectedTotalExperienceYear = "0";
    },
    closeEdit() {
      this.editingSkillModel = {} as TeammemberSkill;
      this.$emit("closeEditModal");
    },
    addSkill() {
      this.showSave = true;
      if (this.teammemberSkillModel.Level && this.teammemberSkillModel.TotalExperienceYears > 0 && this.teammemberSkillModel.SkillId) {
        var skillModel = { ...this.teammemberSkillModel };
        this.saveSkill(skillModel);
        this.selectedSkill = null;
        this.resetSkillForm();
      } else if (this.isGettingSkill) {
        this.$emit("saveSkill");
      }
    },
    fillSkill(item: any) {
      if (item) {
        this.comboboxSkillString = item.Text ? item.Text : item;
      }
    },
    saveSkill(item: TeammemberSkill) {
      this.$emit("saveSkill", item);
    },
    convertTopSkill(val: any) {
      return val;
    },
  },
  watch: {
    comboboxSkillString(newVal) {
      if (!newVal) {
        this.resetSkillForm();
      } else {
        this.showSave = true;
        var findSkill = this.skillList.find((c: any) => c && c.Text.trim().toLowerCase() === newVal.trim().toLowerCase());
        if (findSkill) {
          this.teammemberSkillModel.SkillId = findSkill.id;
        } else {
          this.teammemberSkillModel.SkillId = newVal;
        }
        this.showLevel = true;
      }
    },
    isGettingAllSection(newVal) {
      this.isGettingSkill = newVal;
      if (newVal) {
        this.addSkill();
      }
    },
    uploadedCertificate(newVal) {
      this.uploadedCertificateUrl = newVal;
    },
    sendReqeustLoading(newVal) {
      this.requestLoading = newVal;
    },
    addSkillLoading(newVal) {
      this.loading = newVal;
    },
    removeSkillloading(newVal) {
      this.loading = newVal;
    },
    showEditSkillModal(newVal) {
      this.showEdit = newVal;
    },
    selectedTotalExperienceYear(newVal) {
      if (newVal === "+20") {
        this.teammemberSkillModel.TotalExperienceYears = 21;
      } else {
        this.teammemberSkillModel.TotalExperienceYears = newVal;
      }
    },
    selectedSkillLevel(newVal) {
      this.teammemberSkillModel.Level = newVal;
      if (!newVal) {
        this.showYear = false;
      } else {
        this.showYear = true;
      }
    },
  },
  mounted() {
    this.$emit("getSkills");
    this.selectedJobRoles = this.tmModel?.SpecificRoles;
    this.selectedJobTitle = this.tmModel?.SpecificTitle;

    this.teammemberSkillList.forEach((item: any) => {
      item.IsTopSkill = this.convertTopSkill(item.IsTopSkill);
    });
  },
});
</script>
